import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, ElementRef, Inject } from '@angular/core';
import { Icons } from '@vex/icons/icons';
import { DateFormatPipe } from '@vex/pipes/date-format/date-format.pipe';
import { HelperService } from '@vex/services/helper.service';
import { CloudConnectStateService } from '@vex/constants/cloud-connect-state';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'vex-pre-deployment-dialogue',
  templateUrl: './pre-deployment-dialogue.component.html',
  styleUrls: ['./pre-deployment-dialogue.component.scss'],
  providers: [DateFormatPipe],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ])
  ]
})
export class PreDeploymentDialogueComponent extends Icons implements OnInit {

  postingBlueprint: any = [];
  conflictContext: any = null;
  constructor(
    public helperService: HelperService,
    public cloudConnectStateService: CloudConnectStateService,
    public dialogRef: MatDialogRef<PreDeploymentDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.postingBlueprint = this.data?.postingBlueprint;
    this.conflictContext = this.data?.conflictContext;
  }

  getHeight(height: number = 0) {
    return (window.innerHeight - height).toString() + 'px';
  }

  ngOnInit() {
    
  }

  onCloseModal(dialogRef) {
    dialogRef.close(false);
    this.helperService.onClose(true);
  }

  onClose(dialogRef) {
    dialogRef.close(dialogRef);
    this.helperService.onClose(true);
  }
}
